// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate
} from "react-router-dom";
import Header from "./components/Header";

// LANDING + INTRO
import Landing from "./pages/Landing";
import Introduction from "./pages/Introduction";

// MODULE 1
import CreateSession from "./pages/CreateSession";
import JoinSession from "./pages/JoinSession";
import Onboarding from "./pages/Onboarding";
import PartnerFlow from "./pages/PartnerFlow";
import WaitingRoom from "./pages/WaitingRoom";
import Results from "./pages/Results";
import About from "./pages/About";

// MODULE 2
import Module2Intro from "./pages/module2/Intro";
import Module2Checkin from "./pages/module2/Checkin";
import Module2Bridge from "./pages/module2/Bridge";
import Module2PhaseIntro from "./pages/module2/PhaseIntro";

import "./App.css";

/* HEADER CONTROLLER */
function Layout() {
  const location = useLocation();

  const showHeader =
    location.pathname === "/introduction" ||
    location.pathname === "/create" ||
    location.pathname === "/join" ||
    location.pathname === "/about";

  return (
    <div className="app-root">
      {showHeader && <Header />}
      <main className="app-main">
        <Routes>
          {/* LANDING */}
          <Route path="/" element={<Landing />} />
          <Route path="/introduction" element={<Introduction />} />

          {/* MODULE 1 */}
          <Route path="/create" element={<CreateSession />} />
          <Route path="/join" element={<JoinSession />} />
          <Route path="/about" element={<About />} />
          <Route
            path="/onboarding/:sessionId/:role"
            element={<Onboarding />}
          />
          <Route
            path="/flow/:sessionId/:role"
            element={<PartnerFlow />}
          />
          <Route
            path="/wait/:sessionId/:role"
            element={<WaitingRoom />}
          />
          <Route
            path="/results/:sessionId/:role"
            element={<Results />}
          />

          {/* MODULE 2 */}
          <Route
            path="/module2/:sessionId/:role"
            element={<Module2Intro />}
          />

          {/* 🔑 KLJUČNI DODATEK – default phase = 1 */}
          <Route
            path="/module2/checkin/:sessionId/:role"
            element={<Navigate replace to="../checkin/:sessionId/:role/1" />}
          />

          <Route
            path="/module2/checkin/:sessionId/:role/:phase"
            element={<Module2Checkin />}
          />

          <Route
            path="/module2/bridge/:sessionId/:role/:phase"
            element={<Module2Bridge />}
          />

          <Route
            path="/module2/phase-intro/:sessionId/:role/:phase"
            element={<Module2PhaseIntro />}
          />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
} 
